import React from 'react';
import { Box, Text, Flex, Button } from '@chakra-ui/react';

const SocioSelector = ({ soci, selectedSocioId, onSelect }) => {
  if (!soci || soci.length <= 1) return null;

  return (
    <Box mb={6}>
      <Text fontSize="sm" fontWeight="medium" color="gray.300" mb={2}>
        Per quale socio stai compilando?
      </Text>
      <Flex gap={2} flexWrap="wrap">
        {soci.map((socio) => {
          const id = socio.documentId;
          const isSelected = selectedSocioId === id;
          const label =
            `${socio.nomeSocio || ''} ${socio.cognomeSocio || ''}`.trim();
          return (
            <Button
              key={id}
              size="sm"
              variant={isSelected ? 'solid' : 'outline'}
              colorScheme={isSelected ? 'yellow' : 'gray'}
              color={isSelected ? 'black' : 'gray.200'}
              borderColor="gray.600"
              onClick={() => onSelect(id)}
              flex={{ base: '1 1 calc(50% - 4px)', sm: '0 1 auto' }}
              minW={{ base: 'auto', sm: '120px' }}
            >
              {label || 'Socio'}
            </Button>
          );
        })}
      </Flex>
    </Box>
  );
};

export default SocioSelector;
